import React, {useState} from "react";
import "./EditProfileDOB.css";

const EditProfileDOB = (props) => {
  const [DOB, setDOB] = useState('')

  const onInputChange = (event) => {
    const DOBValue = event.target.value;
    setDOB(DOBValue);
    props.getDOBData(DOBValue);
  }

  const onSubmit = (event) => {
    event.preventDefault();

  }

  return (
    <div className="edit-profile-dob">
      <div className="first-name-h-eading">
        <div className="label-19 nunito-semi-bold-shuttle-gray-14px">Date of Birth</div>
      </div>
      <input 
        onSubmit={onSubmit}
        className="overlap-group-86 border-1px-mischka" 
        type="date" 
        value={DOB}
        placeholder="dd/mm/yyyy"
        onChange={onInputChange}
      />
    </div>
  );
}

export default EditProfileDOB;
